import _ from 'underscore';
import { useCallback, useEffect, useRef } from 'react';

export const useOnClickOutside = ({ onClickOutside, excludedClasses }) => {
  const targetRef = useRef(null);

  const isTargetExcluded = useCallback((target) => {
    if (_.isEmpty(excludedClasses)) {
      return false;
    }

    let parent = target;
    while (parent && parent !== document) {
      for (let i = 0; i < excludedClasses.length; i += 1) {
        if (parent.classList.contains(excludedClasses[i])) {
          return true;
        }
      }
      parent = parent.parentNode;
    }

    return false;
  }, [excludedClasses]);

  const timerIdRef = useRef(null);

  const onClickOutsideCallback = useCallback((event) => {
    // wait for the click event to finish bubbling up the DOM tree
    timerIdRef.current = setTimeout(() => {
      timerIdRef.current = null;
      onClickOutside(event);
    }, 0);
  }, [onClickOutside]);

  const handleClickOutside = useCallback((event) => {
    if (targetRef.current && !targetRef.current.contains(event.target) && !isTargetExcluded(event.target)) {
      onClickOutsideCallback(event);
    }
  }, [isTargetExcluded, onClickOutsideCallback]);

  useEffect(() => {
    if (document && document.addEventListener) {
      document.addEventListener('click', handleClickOutside, true);
    }
    return () => {
      if (document && document.removeEventListener) {
        document.removeEventListener('click', handleClickOutside, true);
      }
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current);
        timerIdRef.current = null;
      }
    };
  }, [handleClickOutside]);

  return { targetRef };
};
